import { render, staticRenderFns } from "./fileHistoryTab.vue?vue&type=template&id=19d4621a&scoped=true&"
import script from "./fileHistoryTab.vue?vue&type=script&lang=js&"
export * from "./fileHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4621a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d4621a')) {
      api.createRecord('19d4621a', component.options)
    } else {
      api.reload('19d4621a', component.options)
    }
    module.hot.accept("./fileHistoryTab.vue?vue&type=template&id=19d4621a&scoped=true&", function () {
      api.rerender('19d4621a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProjectManage/components/project/fileHistoryTab.vue"
export default component.exports